import { render, staticRenderFns } from "./AddNewNBCollector.vue?vue&type=template&id=ac3b138a&"
import script from "./AddNewNBCollector.vue?vue&type=script&lang=js&"
export * from "./AddNewNBCollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports